import { CaracteristiqueChoixTemplateSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const CaracteristiqueChoixTemplateModel: SelectorModel = {
  name: 'caracteristiqueChoixTemplates',
  getSelector: CaracteristiqueChoixTemplateSelectors.selectAllCaracteristiqueChoixTemplatesDictionary,
  isReady: CaracteristiqueChoixTemplateSelectors.selectIsReadyCaracteristiqueChoixTemplate
};
